import { hookstate } from "@hookstate/core";
import { localstored } from "@hookstate/localstored";
import {
  PAGE_LAYOUT_TYPES,
  PAGE_SIZING_TYPES,
} from "../screens/reader/constants";
import { getIsLocalStorageAvailable } from "../utils/getIsLocalStorageAvailable";

export const IS_MOBILE_MAX_WIDTH = 980;
export const VIEWER_MIN_WIDTH_DOUBLE_PAGE = 1600;
const shouldDefaultToDoublePage =
  window?.outerWidth >= VIEWER_MIN_WIDTH_DOUBLE_PAGE;
const detectedIsMobile = window?.innerWidth < IS_MOBILE_MAX_WIDTH;

let defaultLayoutMode = PAGE_LAYOUT_TYPES.single;
if (detectedIsMobile) defaultLayoutMode = PAGE_LAYOUT_TYPES.vertical;

const DEFAULT_SETTINGS_STATE = {
  pageLayout: shouldDefaultToDoublePage
    ? PAGE_LAYOUT_TYPES.double
    : defaultLayoutMode,
  pageSizing: PAGE_SIZING_TYPES.height,
  hasVerticalMargin: true,
  p2pEnabled: true,
  p2pOverlayOpacity: 75,
  showNSFWInterstitial: true,
  showReaderHints: true,
};

export type ReaderSettingsState = {
  pageLayout: string;
  pageSizing: string;
  hasVerticalMargin: boolean;
  p2pEnabled: boolean;
  p2pOverlayOpacity: number;
  showNSFWInterstitial: boolean;
  showReaderHints: boolean;
};

const isLocalStorageAvailable = getIsLocalStorageAvailable();
const STORAGE_KEY = "readerSettingsData";

export const readerSettingsStore = hookstate<ReaderSettingsState>(
  DEFAULT_SETTINGS_STATE,
  isLocalStorageAvailable ? localstored({ key: STORAGE_KEY }) : undefined,
);
